export default __webpack_public_path__ + "501e1b8cf3d9048d48cc447fb0b9423f.png";